import React from 'react'
import {
  Div, Button,
} from 'konsys-ui'
import { Col, Row } from 'antd'
import {
  FullWidthContainer,
  Bar,
  Content,
  Title,
  ButtonBack,
} from './styled'
import TablePrice from '../table-price'
import Promotion from '../promotion'
import GraphicSelector from '../graphic-selector'
import MoreDetailInput from '../more-detail-input'
import ImageInput from '../cover-image'

const SummaryContent = ({
  formValues,
  setFormValues,
  setStep,
  setDisabledRequestQuot,
}) => (
  <FullWidthContainer>
    {/* <Bar>
      <Div>
        <ButtonBack
          inverse
          text='<< ย้อนกลับ'
          onClick={() => setStep(1)}
        />
      </Div>
      <Title>ข้อมูลโปรโมชัน และราคา</Title>
      <Div>
      </Div>
    </Bar> */}
    <Content>
      <Promotion
        formValues={formValues}
        setFormValues={setFormValues}
      />
      <TablePrice
        totalCost={formValues.listCost || []}
        formValues={formValues}
        setFormValues={setFormValues}
        setDisabledRequestQuot={setDisabledRequestQuot}
      />
      <br/>
      <GraphicSelector
        formValues={formValues}
        setFormValues={setFormValues}
      />
      <br/>
      <MoreDetailInput
        formValues={formValues}
        setFormValues={setFormValues}
      />
      <br/>
      <ImageInput
        newFileList={formValues.graphicFile}
        setNewFileList={setFormValues}
        data={formValues.graphicFile}
        formValues={formValues}
      />
    </Content>
  </FullWidthContainer>
)


export default SummaryContent



// WEBPACK FOOTER //
// ./src/pages/package-page/detail/components/summary-content/index.jsx